import { createFileRoute, Link, useSearch } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle } from "lucide-react";
import { z } from "zod";

const Search = z.object({
  status: z.enum(["success", "cancel"]).optional(),
  session_id: z.string().optional(),
});

export const Route = createFileRoute("/checkout-return")({
  validateSearch: (s) => Search.parse(s),
  component: CheckoutReturn,
});

function CheckoutReturn() {
  const { status } = useSearch({ from: "/checkout-return" });
  const success = status === "success";

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-md rounded-xl border border-border bg-card p-8 text-center">
        <div
          className={`mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full ${success ? "bg-emerald-500/10 text-emerald-500" : "bg-muted text-muted-foreground"}`}
        >
          {success ? <CheckCircle2 className="h-6 w-6" /> : <XCircle className="h-6 w-6" />}
        </div>
        <h1 className="text-xl font-semibold">
          {success ? "You're all set" : "Checkout cancelled"}
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {success
            ? "Your 14-day trial has started. We'll only charge your card if you keep going past day 14."
            : "No charge was made. You can pick a plan again whenever you're ready."}
        </p>
        <Button asChild className="mt-6 w-full">
          <Link to={success ? "/dashboard" : "/signup"}>
            {success ? "Go to dashboard" : "Back to signup"}
          </Link>
        </Button>
      </div>
    </div>
  );
}
